import { useState } from 'react';

const faqs = [
  {
    pergunta: 'A Home Office Premium faz projeto completo de escritório?',
    resposta:
      'Sim. Atuamos no projeto e implantação de ambientes corporativos completos: mobiliário, divisórias, carpetes, acústica e marcenaria, do planejamento à entrega e montagem.',
  },
  {
    pergunta: 'Vocês atendem empresas que estão montando uma nova sede?',
    resposta:
      'Sim. Novas sedes são um dos nossos principais focos. Estruturamos toda a ambientação da nova operação, com solução única para todos os ambientes.',
  },
  {
    pergunta: 'Vocês trabalham com arquitetos?',
    resposta:
      'Sim. Executamos e fornecemos soluções de acordo com a especificação do profissional, integrando mobiliário, divisórias e demais componentes ao projeto.',
  },
  {
    pergunta: 'Vocês fornecem mobiliário e divisórias no mesmo projeto?',
    resposta:
      'Sim. Centralizamos mobiliário, divisórias, carpetes, acústica e marcenaria em um único parceiro, simplificando a coordenação do projeto.',
  },
  {
    pergunta: 'Vocês trabalham com carpete corporativo?',
    resposta:
      'Sim. Fornecemos carpete modular e soluções de piso para áreas empresariais, integradas ao restante do projeto.',
  },
  {
    pergunta: 'Vocês atendem fora de Caruaru?',
    resposta:
      'Sim. Atendemos projetos em Pernambuco e avaliamos projetos em todo o Nordeste conforme porte e logística.',
  },
  {
    pergunta: 'Qual o porte de projeto que vocês atendem?',
    resposta:
      'Nosso atendimento prioritário é para projetos corporativos a partir de R$ 50 mil, que geralmente envolvem vários ambientes, diferentes soluções e maior porte logístico. Avaliamos cada projeto conforme as necessidades da empresa.',
  },
  {
    pergunta: 'Quanto tempo leva para receber uma proposta?',
    resposta:
      'Após recebermos as informações do seu projeto (planta, medidas, fotos ou projeto do arquiteto), estruturamos a proposta comercial e o escopo.',
  },
  {
    pergunta: 'A entrega e montagem estão incluídas?',
    resposta:
      'Sim. Coordenamos o fornecimento, a logística e a implantação, garantindo a entrega e montagem de todos os componentes do projeto.',
  },
];

export default function FaqSection() {
  const [aberto, setAberto] = useState<number | null>(0);

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-12 md:mb-16">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Perguntas frequentes
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Dúvidas comuns sobre projetos corporativos.
          </h2>
        </div>

        <div className="max-w-3xl">
          {faqs.map((faq, i) => {
            const isOpen = aberto === i;
            return (
              <div key={faq.pergunta} className="border-b border-background-200/70">
                <button
                  type="button"
                  onClick={() => setAberto(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
                  aria-expanded={isOpen}
                >
                  <span className="text-foreground-900 text-[15px] md:text-[16px] font-medium group-hover:text-primary-600 transition-colors">
                    {faq.pergunta}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 flex-shrink-0">
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-base`}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="pb-5 text-foreground-500 text-[14px] md:text-[15px] leading-relaxed pr-10">
                    {faq.resposta}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}